// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Nvhn","error":"Textarea_error__2EB7o","readonly":"Textarea_readonly__3CzTm","disabled":"Textarea_disabled__1EuK8"};